import { useState, useEffect } from 'react';

/**
 * ブラウザのオンライン状態を追跡するカスタムフック.
 * @returns {boolean} オンラインの場合は true, オフラインの場合は false.
 */
export const useOnlineStatus = (): boolean => {
    // navigator.onLine を初期値としてオンライン状態を管理
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        // オンラインになった時のハンドラ
        const handleOnline = () => setIsOnline(true);
        // オフラインになった時のハンドラ
        const handleOffline = () => setIsOnline(false);

        // イベントリスナーを登録
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // コンポーネントのクリーンアップ時にイベントリスナーを削除
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return isOnline;
};